let admin = {
    name: "Name",
    enterName: "Please enter your name",
    email: "Email",
    enterEmail: "Please enter your email",
    mailFormat: "Please check the email format",
    type: "Type",
    primaryAdministrator: "Primary administrator",
    ordinaryAdministrator: "Ordinary administrator",
    phone: "Phone",
    enterPhone: "Please enter the phone number",
    phoneFormat: "Please check the phone number format",
    pwdSetTime: "Password setting time",
    loginErrorCnt: "Number of login failures",
    lockTime: "Lock time",
    lastLoginTime: "Last login time",
    loginCount: "Login count",
    perm: "Menu Permissions",
    all: "All",
    part: "Part",
    adminDetail: "Administrator Detail",
    addAdmin: "Add Administrator",
    updateAdmin: "Edit Administrator",
    confirmDeleteAdmin: "Delete the selected administrator?",
    noSelectedKeys: "Select the administrator you want to delete"
}

export default admin
